/* ToTopButtonComponent template */
import { FunctionalComponent, h, Host } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { PlaceholderIcons } from '@cewe-designsystem/util_placeholder_icons';
import { ToTopButtonComponent } from './cwc-to-top-button';

/**
 * Definition of  parameters that the template needs to work.
 */
interface ToTopButtonTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: ToTopButtonComponent;
  // Specify parameters that are required to be passed down to the template here.
}

const ToTopButtonTemplate: FunctionalComponent<ToTopButtonTemplateProps> = ({ controller }) => (
  <Host style={controller.footnoteHeight ? { '--footnote-height': controller.footnoteHeight + 'px' } : {}}>
    <button
      class={'float-to-top-button'}
      style={!controller.isScrolled ? { display: 'none' } : {}}
      aria-hidden={'true'}
      tabindex={'-1'}
      onClick={() => controller.scrollToTop()}
    >
      <svg viewBox="0 0 24 24">{PlaceholderIcons.svgArrowUp()}</svg>
    </button>
  </Host>
);

export default ToTopButtonTemplate;
